import { COMMUNITY_IOS_IMAGE_EXTENSIONS } from '@src/constants/fileTypes';
import { useCallback } from 'react';

const useHeicConverter = (imageUrl?: string, fileName?: string) => {
  const isHeicFile = useCallback((url?: string, name?: string) => {
    if (name) {
      const extension = name.split('.').pop()?.toLowerCase();
      return COMMUNITY_IOS_IMAGE_EXTENSIONS.includes(extension || '');
    }
    if (!url) {
      return false;
    }
    const extension = url.split('.').pop()?.toLowerCase();
    return COMMUNITY_IOS_IMAGE_EXTENSIONS.includes(extension || '');
  }, []);

  return {
    isHeicFile: isHeicFile(imageUrl, fileName),
  };
};

export default useHeicConverter;
